import { selectWidgetInstanceState } from '../selectors';
import { StreamingWidgetState } from './WidgetStreamState';
import State from 'store/State';
import { WidgetType } from 'widgets/WidgetType';
import { useSelector } from 'react-redux';
import { useWidgetContext } from 'widgets/WidgetContext';
import { StreamMessage } from 'utils/messages/StreamMessage';
import { useEmbeddedAppAlerts } from 'embedded/store/hooks';
import { useMemo } from 'react';

export const selectWidgetStreamData = (
    state: State,
    widgetType: WidgetType,
    widgetKey: string
) => {
    const widgetState = selectWidgetInstanceState(state, widgetType, widgetKey);
    return widgetState && (widgetState as StreamingWidgetState<unknown>).stream;
};

export const useWidgetMessages: () => StreamMessage[] = () => {
    const { widgetKey, widgetType } = useWidgetContext();
    const embeddedAppAlerts = useEmbeddedAppAlerts();

    const widgetMessages = useSelector(
        (state: State) =>
            selectWidgetStreamData(state, widgetType, widgetKey)?.messages ?? []
    );

    return useMemo(() => {
        return [
            ...embeddedAppAlerts.map((a) => ({ message: a })),
            ...widgetMessages,
        ];
    }, [embeddedAppAlerts, widgetMessages]);
};
